import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardText, CardTitle, Col, Label, Row, Table, Tooltip } from 'reactstrap';
import BZAPIService from '../../../services/BZAPIService';
import Select from 'react-select';
import Loader from '../../common/Loader';
import { capitalize, isArray, isEmpty } from 'lodash';

export default function HistoryTab({ vendorId }) {
  const [history, setHistory] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [historyType, setHistoryType] = useState({ label: 'All', value: 'all' });
  const [isOpenTooltip, setIsOpenTooltip] = useState({});

  const selectStyles = {
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: isFocused ? 'white' : isSelected ? 'white' : 'black'
      };
    }
  };

  async function getHistory(e) {
    setHistoryType(e?.value?.length ? e : historyType);
    try {
      const res = await BZAPIService.getBugServiceHistory(vendorId, e?.value?.length ? e.value : historyType.value);
      setHistory(
        res?.data?.results?.filter(h => {
          return h?.vendorData.configuration_completed === true;
        })
      );
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getHistory();
  }, []);

  const toggleTooltip = (e, id) => {
    console.log('e: ', e);
    setIsOpenTooltip(e.type === 'mouseover' ? id : '');
  };
  return (
    <>
      <Card className="mb-4">
        <CardBody className="fs--1">
          <div className="row" />
          <div />
          {isLoading ? (
            <Loader />
          ) : (
            <div>
              <CardTitle>Bug Service Execution History</CardTitle>
              <CardText className="mb-4">Displaying up to the last 10 executions</CardText>
              <Row>
                {' '}
                <Col sm={'4'}>
                  <Label>Choose data to display:</Label>
                  <Select
                    options={[
                      { label: 'All', value: 'all' },
                      { label: 'Bugs inserted', value: 'bugsinserted' },
                      { label: 'Bugs updated', value: 'bugsupdated' },
                      { label: 'Errors', value: 'errors' }
                    ]}
                    value={historyType}
                    onChange={e => getHistory(e)}
                    menuPortalTarget={document.body}
                    styles={selectStyles}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#253746',
                        primary: '#bd472a'
                      },
                      width: '200px'
                    })}
                    className="w-52 basic-multi-select"
                  />
                </Col>
              </Row>

              <div className="mb-6">
                {!isEmpty(history) ? (
                  <Table bordered striped style={{ marginTop: '20px' }}>
                    <thead className="card-header">
                      <tr>
                        <th>Ended</th>
                        {Object.keys(history[0]?.vendorData)
                          ?.slice(0, 6)
                          ?.map((label, index) =>
                            label === 'crawlErrors' ? null : (
                              <th key={'table-head-' + index}>
                                {label.replace(/([A-Z])/g, ' $1').replaceAll('_', ' ')}
                              </th>
                            )
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {history?.map((h, i) => (
                        <tr key={h.endedAt}>
                          <td>{h.endedAt}</td>
                          {Object.keys(h?.vendorData)
                            ?.filter(v => v !== 'crawlErrors')
                            ?.slice(0, 6)
                            ?.map((value, index) => (
                              <td
                                key={'table-value-' + value + index}
                                className="font-weight-bold"
                                data-testid={'key-row'}
                              >
                                {/* If array or errors, display warning, else not. If not array, print string */}
                                <p className="py-2">
                                  {isArray(h?.vendorData[value]) && h?.vendorData[value]?.length ? (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="16"
                                        width="16"
                                        viewBox="0 0 512 512"
                                        id={'error-target-' + h.id}
                                      >
                                        <path
                                          fill="#bd472a"
                                          d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                                        />
                                      </svg>
                                      <Tooltip
                                        placement="top"
                                        isOpen={isOpenTooltip === 'error-target-' + h.id}
                                        target={'error-target-' + h.id}
                                        autohide={true}
                                        toggle={e => toggleTooltip(e, 'error-target-' + h.id)}
                                      >
                                        {capitalize(h.vendorData?.errors[0]?.value)}
                                      </Tooltip>
                                    </>
                                  ) : isArray(h?.vendorData[value]) && !h?.vendorData[value]?.length ? (
                                    <p>-</p>
                                  ) : h?.vendorData[value] === 0 ? (
                                    '-'
                                  ) : (
                                    h?.vendorData[value]
                                  )}
                                </p>
                              </td>
                            ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <div className="mt-4">
                    <strong>No execution logs found</strong>
                  </div>
                )}
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
}

HistoryTab.propTypes = {
  vendorId: PropTypes.string
};
